import { useEffect, useState } from 'react';
import LoadingContent from '../../components/LoadingContent';
import { additionalDetail } from '../../api/additional-details';
import { TableBody, TableHeading, TableHeadingCol, TableRow } from '../../components/Table';
import TableRowItem from './components/TableRowItem';
import usePagainate from '../../hooks/usePaginate';
import Pagination from '../../components/Pagination';

export default function BookTrailDashboard() {
  const [data, setdata] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const { currentPage, resultsPerPage, nextPage, prevPage, setResultsPerPage, resetPage } = usePagainate();
  useEffect(() => {
    const fetch = async () => {
      const trailData = await additionalDetail.booktrailData();
      setdata(Array.isArray(trailData) ? trailData : []);
      setLoading(false);
    };
    fetch();
  }, []);

  // Reset to first page when page size changes
  useEffect(() => {
    resetPage();
  }, [resultsPerPage]);
  if (loading) {
    return <LoadingContent />;
  }
  const startIndex = (currentPage - 1) * resultsPerPage;
  const endIndex = startIndex + resultsPerPage;
  const paginated = data.slice(startIndex, endIndex);

  return (
    <div className="w-full h-full flex flex-col gap-5 py-2 px-2">
      <table className="w-full h-full table-auto">
        <TableHeading>
          <TableRow>
            <TableHeadingCol label="DATE" />
            <TableHeadingCol label="CHILD NAME" />
            <TableHeadingCol label="PARENT NAME" />
            <TableHeadingCol label="PARENT EMAIL" />
            <TableHeadingCol label="PHONE NO." />
            <TableHeadingCol label="DEVICE" />
            <TableHeadingCol label="CLASS" />
            <TableHeadingCol label="DELETED" />
          </TableRow>
        </TableHeading>
        <TableBody>
          {paginated.map((item: any, index) => (
            <TableRow key={index}>
              <TableRowItem data={item} />
            </TableRow>
          ))}
        </TableBody>
      </table>
      <Pagination
        count={data.length}
        currentPage={currentPage}
        nextPage={nextPage}
        prevPage={prevPage}
        resultsPerPage={resultsPerPage}
        setResultsPerPage={setResultsPerPage}
      />
    </div>
  );
}
